module.exports = __webpack_public_path__ + "static/bloq-preview-half-f9803f28cb3077404558e06ec675c0be.png";